import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILED,
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAILED,
  GET_VARIANT,
  GET_VARIANT_SUCCESS,
  GET_VARIANT_FAILED,
  GET_PRODUCTS_INVONTORY,
  GET_PRODUCTS_INVONTORY_SUCCESS,
  GET_PRODUCTS_INVONTORY_FAILED,
  GET_PRODUCT_VARIANTS,
  GET_PRODUCT_VARIANTS_SUCCESS,
  GET_PRODUCT_VARIANTS_FAILED,
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_FAILED,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILED,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS_SUCCESS,
  GET_PRODUCT_VARIANT_INVENTORY_ITEMS_FAILED,
  GET_PARTNER_CATEGORIES,
  GET_PARTNER_CATEGORIES_SUCCESS,
  GET_PARTNER_CATEGORIES_FAILED, CLEAR_PRODUCT,
} from './constants';

export const initialState: State = {
  productsList: [],
  allProductsList: [],
  productsInventoryList: [],
  productVariantList: [],
  variantFeaturesList: [],
  categoriesList: [],
  usersByCenterId: [],
  usersBeAdminCenter: [],
  productVariantInventoryItemsList: [],
  productVariantInventoryItemsListCount: 0,
  partnerCategoriesList: [],
  variant: {
    productId: 0,
    sellerName: '',
    id: '',
    sellerId: '',
    createdTime: '',
    expiredTime: '',
  },
  product: {
    name: '',
    code: '',
    id: 0,
    categoryName: '',
    weight: 0,
    width: 0,
    height: 0,
    length: 0,
    shippingWeight: 0,
    shippingWidth: 0,
    shippingHeight: 0,
    shippingLength: 0,
    unit: '',
    serialNumber: 0,
    description: '',
  },
  count: 0,
  productVariantListCount: 0,
  loading: false,
  categoryLoading: false,
  allProductsListLoading: false,
  error: '',
};

export const ProductsReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_PRODUCTS:
        draft.loading = true;
        break;
      case GET_PRODUCTS_SUCCESS:
        draft.productsList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_PRODUCTS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PRODUCT:
        draft.loading = true;
        break;
      case GET_PRODUCT_SUCCESS:
        draft.product = action.data;
        draft.loading = false;
        break;
      case GET_PRODUCT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CATEGORIES:
        draft.categoryLoading = true;
        break;
      case GET_CATEGORIES_SUCCESS:
        draft.categoriesList = action.data;
        draft.categoryLoading = false;
        break;
      case GET_CATEGORIES_FAILED:
        draft.error = action.error;
        draft.categoryLoading = false;
        break;

      case GET_VARIANT:
        draft.loading = true;
        break;
      case GET_VARIANT_SUCCESS:
        draft.variant = action.data;
        draft.variantFeaturesList = action.data.features;
        draft.loading = false;
        break;
      case GET_VARIANT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ALL_PRODUCTS:
        draft.allProductsListLoading = true;
        break;
      case GET_ALL_PRODUCTS_SUCCESS:
        draft.allProductsList = action.data;
        draft.allProductsListLoading = false;
        break;
      case GET_ALL_PRODUCTS_FAILED:
        draft.error = action.error;
        draft.allProductsListLoading = false;
        break;

      case GET_PRODUCTS_INVONTORY:
        draft.loading = true;
        break;
      case GET_PRODUCTS_INVONTORY_SUCCESS:
        draft.productsInventoryList = action.data;
        draft.loading = false;
        break;
      case GET_PRODUCTS_INVONTORY_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PRODUCT_VARIANTS:
        draft.loading = true;
        break;
      case GET_PRODUCT_VARIANTS_SUCCESS:
        draft.productVariantList = action.data.content;
        draft.productVariantListCount = action.data.totalElements;
        draft.loading = false;
        break;
      case GET_PRODUCT_VARIANTS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PRODUCT_VARIANT_INVENTORY_ITEMS:
        draft.loading = true;
        break;
      case GET_PRODUCT_VARIANT_INVENTORY_ITEMS_SUCCESS:
        draft.productVariantInventoryItemsList = action.data.content;
        draft.productVariantInventoryItemsListCount = action.data.totalElements;
        draft.loading = false;
        break;
      case GET_PRODUCT_VARIANT_INVENTORY_ITEMS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PARTNER_CATEGORIES:
        draft.loading = true;
        break;
      case GET_PARTNER_CATEGORIES_SUCCESS:
        // @ts-ignore
        draft.partnerCategoriesList = action.data;
        draft.loading = false;
        break;
      case GET_PARTNER_CATEGORIES_FAILED:
        draft.loading = false;
        break;
      case CLEAR_PRODUCT:
        draft.product = {
          name: '',
          code: '',
          id: 0,
          categoryName: '',
          weight: 0,
          width: 0,
          height: 0,
          length: 0,
          shippingWeight: 0,
          shippingWidth: 0,
          shippingHeight: 0,
          shippingLength: 0,
          unit: '',
          serialNumber: 0,
          description: '',
        };
        break;

      default:
        break;
    }
  });
export default ProductsReducer;
